import { Component, Input } from '@angular/core';

@Component({
  selector: 'main-footer',
  templateUrl: 'main-footer.html'
})
export class MainFooterComponent {

  @Input('menuVisible') menuVisible: boolean;

  constructor(
  ) {
  }

  ngOnInit() {
  }

  ngOnDestroy() {
  }
}



// WEBPACK FOOTER //
// ./src/components/main-footer/main-footer.ts